<template>
	<tr class="v2im-row">
		<td>
			<div class="v2im-row__rule">
				<button
					v-tippy="{ appendTo: () => $el }"
					:content="$t(`inventory_modal.${type === 'black' ? 'remove_from' : 'add_to'}_blacklist_hint`)"
					type="button"
					class="v2im-row__rule-btn"
					:class="{ 'v2im-row__rule-btn--black': type === 'black' }"
					:disabled="isBusy"
					role="checkbox"
					:aria-checked="type === 'black'"
					aria-label="blacklist"
					@click="handleActionButtonClick('black')"
				>
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" x2="6" y1="6" y2="18"/><line x1="6" x2="18" y1="6" y2="18"/></svg>
				</button>
				<button
					v-tippy="{ appendTo: () => $el }"
					:content="$t(`inventory_modal.${type === 'white' ? 'remove_from' : 'add_to'}_whitelist_hint`)"
					type="button"
					class="v2im-row__rule-btn"
					:class="{ 'v2im-row__rule-btn--white': type === 'white' }"
					:disabled="isBusy"
					role="checkbox"
					:aria-checked="type === 'white'"
					aria-label="whitelist"
					@click="handleActionButtonClick('white')"
				>
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" :stroke-width="type === 'white' ? 3 : 2.5"><polyline points="20 6 9 17 4 12"/></svg>
				</button>
			</div>
		</td>
		<td>{{ device.location_name || '—' }}</td>
		<td>{{ device.city || '—' }}</td>
		<td>{{ device.address || '—' }}</td>
		<td>{{ device.name || '—' }}</td>
		<td>
			<span v-if="device.resolution" class="v2im-row__spec">
				<svg
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					:style="{ transform: isVerticalSpec ? 'rotate(90deg)' : 'none' }"
				><rect width="20" height="14" x="2" y="3" rx="2"/></svg>
				<span>{{ device.resolution }}</span>
			</span>
			<template v-else>&mdash;</template>
		</td>
		<td class="v2im-row__num">{{ device.count_screen || '—' }}</td>
		<td>
			<span class="v2im-row__uptime" :class="uptimeClass">{{ uptime.value }}</span>
		</td>
		<td class="v2im-row__num">{{ device.ad_plays_count || '—' }}</td>
		<td class="v2im-row__num">{{ ots || '—' }}</td>
		<td class="v2im-row__num v2im-row__nowrap">{{ Math.round(cost.min) }}&nbsp;&mdash;&nbsp;{{ Math.round(cost.max) }}</td>
	</tr>
</template>


<script>
import OriginalRow from '@/ui-overrides/default/pages/request/create/inventory-details-modal/inventory-table-row.vue';

export default {
	name: 'V2InventoryTableRow',

	extends: OriginalRow,

	computed: {
		uptimeClass() {
			const color = this.uptime && this.uptime.color;
			if (color === 'green') return 'v2im-row__uptime--green';
			if (color === 'purple') return 'v2im-row__uptime--yellow';
			if (color === 'red') return 'v2im-row__uptime--red';
			return '';
		},

		isVerticalSpec() {
			const res = this.device && this.device.resolution;
			if (!res || typeof res !== 'string') return false;
			const parts = res.split('x');
			if (parts.length !== 2) return false;
			const w = parseInt(parts[0]);
			const h = parseInt(parts[1]);
			return h > w;
		},
	},
};
</script>


<style lang="sass" scoped>
@import '~@/assets/styles/v2-tokens.sass'

$mono: 'JetBrains Mono', 'Menlo', monospace

// ── Rule cell ──────────────────────
.v2im-row__rule
	display: flex
	gap: 4px

.v2im-row__rule-btn
	width: 28px
	height: 28px
	border-radius: 8px
	border: 1px solid $v2-border
	background: $v2-card-bg
	color: $v2-text-muted
	display: inline-flex
	align-items: center
	justify-content: center
	cursor: pointer
	transition: all 0.15s
	padding: 0

	svg
		width: 13px
		height: 13px

	&:hover:not(:disabled)
		border-color: $v2-text-muted
		color: $v2-text

	&:disabled
		opacity: 0.5
		cursor: not-allowed

	&--black
		background: $v2-red
		border-color: $v2-red
		color: white

		&:hover:not(:disabled)
			background: $v2-red
			border-color: $v2-red
			color: white

	&--white
		background: $v2-green
		border-color: $v2-green
		color: white

		&:hover:not(:disabled)
			background: $v2-green
			border-color: $v2-green
			color: white

// ── Spec cell ──────────────────────
.v2im-row__spec
	display: inline-flex
	align-items: center
	gap: 6px

	svg
		width: 12px
		height: 12px
		color: $v2-text-muted

// ── Uptime cell ────────────────────
.v2im-row__uptime
	font-weight: 600

	&--green
		color: $v2-green

	&--yellow
		color: $v2-orange

	&--red
		color: $v2-red

// ── Numeric cells ──────────────────
.v2im-row__num
	font-family: $mono

.v2im-row__nowrap
	white-space: nowrap
</style>
